import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { SettingsPageFrame } from '@eluve/blocks';
import { Stack } from '@eluve/components';

import { BackfillEmrDataButton } from './BackfillEmrDataButton';
import {
  LocationsView,
  LocationsViewMode,
  LocationsViewToggle,
} from './LocationsTable';

export const LocationsPage: React.FC = () => {
  const { tenantId } = useParams() as { tenantId: string };
  const [view, setView] = useState<LocationsViewMode>('table');

  return (
    <SettingsPageFrame
      size="wide"
      title="Locations"
      description="Locations synced from your EMR appear below — rename any location, or switch to the Tree view to manage the hierarchy."
      actions={
        <Stack direction="horizontal" gap={3} align="center" fullWidth={false}>
          <BackfillEmrDataButton tenantId={tenantId} />
          <LocationsViewToggle view={view} onViewChange={setView} />
        </Stack>
      }
    >
      <LocationsView tenantId={tenantId} view={view} />
    </SettingsPageFrame>
  );
};
